import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { isAuthenticated } from 'utils/authUtils';

const PublicRoute = ({ component, path }: any) => {
  // Use enhanced authentication check
  const authenticated = isAuthenticated();
  
  return authenticated ? (
    <Redirect to="/conversations-nearby" />
  ) : (
    <Route exact path={path} component={component} />
  );
};

export default PublicRoute;
